<template>
  <div>
    <v-row>
      <v-col>
        <v-banner color="transparent" single-line>
          <h1 class="title">Notes</h1>
          <v-btn dark absolute bottom small right fab @click.stop="dialogAddNote = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-banner>
      </v-col>
    </v-row>
    <v-row class="fill-height" align="start" justify="start">
      <template v-for="(item, i) in getCurrentClientNotes">
        <v-col :key="i" cols="12" lg="3" md="4" sm="6" xs="12">
          <v-hover v-slot:default="{ hover }">
            <v-card class="text-left" color="yellow lighten-3" light>
              <v-card-text style="padding:5px 16px 0px 16px">
                <div>{{ item.date | mom }}</div>
              </v-card-text>
              <v-card-title>
                <v-text-field
                  v-model="item.title"
                  outlined
                  label="Title"
                  :readonly="item.editNote"
                  hide-details
                ></v-text-field>

                <v-spacer />
                <div v-if="item.editNote">
                  <v-btn
                    class="ma-2"
                    outlined
                    x-small
                    fab
                    color="black"
                    @click="item.editNote = !item.editNote"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn class="ma-2" outlined x-small fab color="black" @click="editNote(item)">
                    <v-icon>mdi-floppy</v-icon>
                  </v-btn>
                </div>
              </v-card-title>
              <v-card-text>
                <v-textarea
                  v-model="item.description"
                  outlined
                  label="Description"
                  auto-grow
                  :readonly="item.editNote"
                  hide-details
                ></v-textarea>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </template>
      <v-dialog v-model="dialogAddNote" max-width="600">
        <v-card>
          <v-card-title class="headline">Add new note</v-card-title>
          <v-card-text>
            <v-form>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Title"
                    v-model="newNote.title"
                    hide-details="auto"
                    outlined
                    placeholder="Title"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    outlined
                    label="Description"
                    v-model="newNote.description"
                    placeholder="Description"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="dialogAddNote = false">Cancel</v-btn>
            <v-btn dark bottom right color="success" @click="addNewNote">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  name: "ClientNotes",
  data: () => ({
    currentClientId: null,
    newNote: {
      title: null,
      description: null,
      date: null
    },
    dialogAddNote: false,
    dialogEditNote: false
  }),
  created() {
    this.currentClientId = this.getCurrentClient.id;
  },
  filters: {
    mom: function(date) {
      return moment(date.toDate()).format("dddd, D MMMM YYYY");
    }
  },
  computed: {
    ...mapGetters(["getCurrentClient", "getCurrentClientNotes"])
  },
  methods: {
    ...mapActions(["createNewNote", "updateNote"]),
    addNewNote() {
      this.newNote.date = new Date();
      let payload = {
        clientId: this.currentClientId,
        note: this.newNote
      };
      this.createNewNote(payload);
      this.newNote = {
        title: null,
        description: null,
        date: null
      };
      this.dialogAddNote = false;
    },
    editNote(item) {
      item.editNote = true;
      let payload = {
        clientId: this.currentClientId,
        note: item
      };
      this.updateNote(payload);
    }
  }
};
</script>

<style></style>
